// client/src/hooks/useTemplateUserPreference.js
import { useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../services/api';
import useAlert from './useAlert';

const BASE_ROUTE = 'templates/preferences';

const queryKeys = {
    'anamnese': 'templatesAnamnese',
    'certificado': 'templatesCertificado',
    'contrato': 'templatesContrato',
    'mensagem': 'templatesMensagem',
    'recibo': 'templatesRecibo',
};

export const useMutateTemplateUserPreference = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();

    const updatePreference = useMutation({
        mutationFn: async ({ templateId, tipoTemplate, ativoParaEscopo }) => {
            const payload = { templateId, tipoTemplate, ativoParaEscopo };
            const response = await apiClient.post(`/${BASE_ROUTE}`, payload);
            return response.data;
        },
        onSuccess: (data, variables) => {
            const queryKeyToInvalidate = queryKeys[variables.tipoTemplate];
            if (queryKeyToInvalidate) {
                queryClient.invalidateQueries({ queryKey: [queryKeyToInvalidate] });
            }
            setAlert('Preferência do template atualizada com sucesso!', 'success');
        },
        onError: (err, variables) => {
            const errorMsg = err.response?.data?.error || `Erro ao atualizar preferência para o tipo ${variables.tipoTemplate}`;
            setAlert(errorMsg, 'danger');
            console.error("FRONTEND LOG: updatePreference - Erro:", err);
        },
    });

    return {
        updatePreference,
        isUpdatingPreference: updatePreference.isPending
    };
};